import { render, staticRenderFns } from "./GoodsContent.vue?vue&type=template&id=16ec0a5c&"
import script from "./GoodsContent.vue?vue&type=script&lang=ts&"
export * from "./GoodsContent.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports